import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import FormError from "../../../shared/components/FormError";
import { loadEmployeeStatusAddDataRequest } from "../redux/Actions";
import EmployeeStatusForm from "./EmployeeStatusForm";

const EmployeeStatusAdd = ({ handleClose }) => {
  const dispatch = useDispatch();
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  let { loading, error } = useSelector((state) => state.employeeStatus);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        handleClose(true);
      } else {
        setErrorMessage(error.msg);
      }
      setShouldCloseModal(false);
    }
  }, [loading, error, shouldCloseModal]);

  function submit(values) {
    delete values.id;
    dispatch(loadEmployeeStatusAddDataRequest(values));
    setShouldCloseModal(true);
  }
  function cancel() {
    handleClose(false);
  }
  return (
    <>
      <FormError>
        {errorMessage}
      </FormError>
      <EmployeeStatusForm submit={submit} cancel={cancel} />;
    </>
  );
};

export default EmployeeStatusAdd;
